<div class="page-head">
  <h1>{{ title() }}</h1>
  <input
    class="search"
    type="search"
    placeholder="Search orders…"
    [value]="search()"
    (input)="setSearch($any($event.target).value)"
  />
</div>

@if (loading()) {
  <p class="muted">Loading…</p>
} @else if (error(); as message) {
  <div class="error-banner">{{ message }}</div>
} @else if (estimates().length === 0) {
  <div class="empty">
    <p class="muted">{{ emptyMessage() }}</p>
  </div>
} @else if (pageRows().length === 0) {
  <div class="empty">
    <p class="muted">No orders match your search.</p>
  </div>
} @else {
  <div class="list">
    <div class="list-head">
      <span>Order</span>
      <span>Status</span>
      <span>Quote</span>
      <span>Quote file</span>
      <span></span>
    </div>
    @for (est of pageRows(); track est.customerId) {
      <a
        class="list-row"
        [routerLink]="
          est.kind === 'diy'
            ? ['/diy-orders', est.orderId]
            : ['/estimates', est.customerId]
        "
      >
        <span class="cell strong">{{ est.name }}</span>
        <span class="cell">
          <span class="badge status">{{ est.status }}</span>
        </span>
        <span class="cell">
          <span
            class="badge quote"
            [class.approved]="est.supplierQuoteStatus === 'approved'"
          >
            {{ statusLabel(est.supplierQuoteStatus) }}
          </span>
        </span>
        <span class="cell muted">
          {{ est.hasQuote ? "Quote uploaded" : "No quote yet" }}
        </span>
        <span class="cell chev">›</span>
      </a>
    }
  </div>

  <footer class="pager">
    <span class="pager-info">{{ total() }} orders</span>
    <div class="pager-controls">
      <button type="button" (click)="setPage(-1)" [disabled]="page() === 0">
        ‹ Prev
      </button>
      <span class="pager-page">{{ page() + 1 }} / {{ pageCount() }}</span>
      <button
        type="button"
        (click)="setPage(1)"
        [disabled]="page() >= pageCount() - 1"
      >
        Next ›
      </button>
    </div>
  </footer>
}
